module.exports = __webpack_public_path__ + "static/img/classroom_5.9208df4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/classroom_5.jpg
// module id = etcM
// module chunks = 3